import React from 'react';
import { BotChatContainer, BotChatMessage, BotMsgError, BotMsgSection } from './styled';
import { CloseCircleOutlined } from '@ant-design/icons';

function ErrorInChat({ error }) {
  return (
    <BotChatContainer>
      <BotMsgSection>
        <BotChatMessage>
          <BotMsgError>
            <CloseCircleOutlined
              style={{
                color: '#FF4D4F',
                fontSize: 64,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
            <h4>{error?.title || 'Error'}</h4>
            <p>{error?.description}</p>
          </BotMsgError>
        </BotChatMessage>
      </BotMsgSection>
    </BotChatContainer>
  );
}

export default ErrorInChat;
